var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatterySecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 22C7.53333 22 7.35417 21.9292 7.2125 21.7875C7.07083 21.6458 7 21.4667 7 21.25V4.35C7 4.13333 7.07083 3.95417 7.2125 3.8125C7.35417 3.67083 7.53333 3.6 7.75 3.6H10V2H14V3.6H16.25C16.4667 3.6 16.6458 3.67083 16.7875 3.8125C16.9292 3.95417 17 4.13333 17 4.35V21.25C17 21.4667 16.9292 21.6458 16.7875 21.7875C16.6458 21.9292 16.4667 22 16.25 22H7.75ZM8.5 13.9H15.5V5.1H8.5V13.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatterySecondary);
export default __webpack_public_path__ + "static/media/battery-secondary.f62abcba3c334bfc52b0fa1234661723.svg";
export { ForwardRef as ReactComponent };